// Committee validation limits
export const COMMITTEE_VALIDATION = {
  NAME_MIN_LENGTH: 3,
  NAME_MAX_LENGTH: 100
};

// Committee error messages
export const COMMITTEE_ERRORS = {
  NAME_REQUIRED: 'Committee name is required',
  NAME_TOO_SHORT: 'Committee name must be at least 3 characters',
  NAME_TOO_LONG: 'Committee name cannot exceed 100 characters',
  NAME_EXISTS: 'A committee with this name already exists',
  USERS_REQUIRED: 'At least one user must be selected'
};

// Committee success messages
export const COMMITTEE_SUCCESS = {
  CREATED: 'Committee created successfully',
  UPDATED: 'Committee updated successfully',
  DELETED: 'Committee deleted successfully',
  USERS_UPDATED: 'Committee members updated successfully'
};